const appEnv = {
  PUB_MODE: "r5-security",
  PUB_API_GATEWAY_ENDPOINT_OPERATION: "https://2n6yts7thj.execute-api.ap-northeast-1.amazonaws.com/r5-security",
  PUB_API_GATEWAY_ENDPOINT_COMMON: "https://bip1abmqhh.execute-api.ap-northeast-1.amazonaws.com/r5-security",
  PUB_API_GATEWAY_ENDPOINT_EMERGENCY: "https://ztdfuk3gmd.execute-api.ap-northeast-1.amazonaws.com/r5-security",
  PUB_AUTH_ENDPOINT: "https://4aeltqksf5.execute-api.ap-northeast-1.amazonaws.com/dev",
  PUB_IDENTITY_POOL_ID: "ap-northeast-1:f0ba74c4-1229-4a3a-8403-cee93fbeab02",
  PUB_USER_POOL_ID: "ap-northeast-1_cOaze6IOc",
  PUB_CLIENT_ID: "88vcb7gekt4a95sob0u0ra8n9",
  PUB_CONTENTS_BUCKET: "disaster-emergency-contents-r5-security",
  PUB_S3_BUCKET_ENDPOINT: null,
  PUB_AUTHORIZATION_AUTH_ENDPOINT: "https://4aeltqksf5.execute-api.ap-northeast-1.amazonaws.com/dev",
  PUB_PEPPER_KEY_OF_CIPHER: "ThisIsCipherKey"
};

export default appEnv;
